import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-lg-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Departmanlar")
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body pt-0" }
const _hoisted_6 = { class: "table-responsive" }

import { defineComponent, ref, computed } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import List from "./components/List.vue";
import Add from "./components/Add.vue";
//import { components } from "@/assets/ts";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const store = useStore();
const isActive = ref(false);
store.dispatch(Actions.DEPARTMENT_LIST);

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Add)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(List)
        ])
      ])
    ])
  ], 64))
}
}

})